import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SeFeApiService } from 'se-fe-api'

@Injectable({
  providedIn: 'root'
})
export class ResendVerificationService {

  constructor(
    private api: SeFeApiService
  ) { }

  public resend(uuid: string): Observable<any> {
    const url = `users/resend_confirmation_email/${uuid}`

    return this.api.post(url, {})
  }
}
